module.exports = __webpack_public_path__ + "img/icon-ceremony.3dcaf51c.png";